import { render } from "./AddVente.vue?vue&type=template&id=7ddc9aa0&scoped=true&ts=true"
import script from "./AddVente.vue?vue&type=script&lang=ts"
export * from "./AddVente.vue?vue&type=script&lang=ts"

import "./AddVente.vue?vue&type=style&index=0&id=7ddc9aa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddc9aa0"]])

export default __exports__